import { useDispatch } from "react-redux";
import { getToday } from "@/services/Utils";
import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";
import { EXPORT_CONFIG } from "../settings.config";

export const useActivityExport = () => {
	const dispatch = useDispatch();

	const handleExport = () => {
		const fileName = `${getToday()} ${EXPORT_CONFIG.filePrefix}.xlsx`;

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: {},
					show: true,
					url: EXPORT_CONFIG.url,
					name: fileName,
					type: EXPORT_CONFIG.type,
					api: EXPORT_CONFIG.api,
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	return { handleExport };
};
